import { Component } from '@angular/core';
import { EtlIngestionService } from '../../services/etl-ingestion/etl-ingestion.service';
import { AppService } from '../../app.service';
import { NotificationSettingsService } from '../../services/notification-settings/notification-settings.service';
import { catchError, finalize, tap } from 'rxjs';

@Component({
    selector: 'app-notification-settings',
    templateUrl: './notification-settings.component.html',
    styleUrl: './notification-settings.component.css',
})
export class NotificationSettingsComponent {
    public selectedCreditorId: string = '';
    public creditorCompanyName: string = '';
    public sms: any | null;
    public email: any | null;

    public smsPlatformTypeList: any | null = null;
    public filteredSmsPlatformTypeList: any | null = null;

    public emailPlatformTypeList: any | null = null;
    public filteredEmailPlatformTypeList: any | null = null;

    public constructor(
        private etlIngestionService: EtlIngestionService,
        private notificationSettingsService: NotificationSettingsService,
        public appService: AppService
    ) {}

    ngOnInit() {
        this.notificationSettingsService
            .getSmsPlatformTypeList()
            .subscribe((res: any) => {
                if (!!res && Array.isArray(res) && res.length > 0) {
                    this.smsPlatformTypeList = res;
                }
            });

        this.notificationSettingsService
            .getEmailPlatformTypeList()
            .subscribe((res: any) => {
                if (!!res && Array.isArray(res) && res.length > 0) {
                    this.emailPlatformTypeList = res;
                }
            });
    }

    onSelectCreditor(event: any) {
        this.selectedCreditorId = event.CreditorId;
        this.creditorCompanyName = event.CompanyName;

        this.appService.pageSpinnerVisible = true;
        this.notificationSettingsService
            .getNotificationSettings('creditor/' + this.selectedCreditorId)
            .subscribe((res: any) => {
                this.appService.pageSpinnerVisible = false;

                this.sms = this.smsPlatformTypeList.find(
                    (i: any) => i.name === res.sms
                );
                this.email = this.emailPlatformTypeList.find(
                    (i: any) => i.name === res.email
                );
            });
    }

    filterSmsPlatformType(event: any) {
        let filteredItems: any[] = [];
        let query = event.query;

        for (let i = 0; i < (this.smsPlatformTypeList as any[]).length; i++) {
            let item = (this.smsPlatformTypeList as any[])[i];
            if (
                item.value.toString().indexOf(query) !== -1 ||
                item.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
            ) {
                filteredItems.push(item);
            }
        }

        this.filteredSmsPlatformTypeList = filteredItems;
    }

    filterEmailPlatformType(event: any) {
        let filteredItems: any[] = [];
        let query = event.query;

        for (let i = 0; i < (this.emailPlatformTypeList as any[]).length; i++) {
            let item = (this.emailPlatformTypeList as any[])[i];
            if (
                item.value.toString().indexOf(query) !== -1 ||
                item.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
            ) {
                filteredItems.push(item);
            }
        }

        this.filteredEmailPlatformTypeList = filteredItems;
    }

    validateInputs(): boolean {
        if (!this.sms || !this.email) {
            this.appService.showCommonMessageDialog(
                'Validation',
                'Please provide all inputs'
            );
            return false;
        }
        return true;
    }

    onClickSubmit() {
        const isValid = this.validateInputs();
        this.appService.pageSpinnerVisible = true;
        if (isValid) {
            this.notificationSettingsService
                .putNotificationSettings(
                    this.sms.name,
                    this.email.name,
                    'creditor/' + this.selectedCreditorId
                )
                .pipe(
                    tap(() => {
                        this.appService.showCommonMessageDialog(
                            'Success',

                            'Payment Gateway Config has been successfully updated.'
                        );
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.appService.pageSpinnerVisible = false;
                    })
                )
                .subscribe();
        }
    }
}
